import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sentencecase' })
export class SentenceCasePipe implements PipeTransform {
  transform(sentence: string, ...args: unknown[]): string {
    if (!sentence || typeof sentence !== 'string')
      return '';

    const trimmed = sentence.trim();
    if (!trimmed)
      return '';

    return trimmed[0].toUpperCase() + trimmed.slice(1);

    // TRUE sentence case:
    // return sentence[0].toUpperCase() + sentence.substring(1).toLowerCase();
  }
}
